import script from "./ContentHolder.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentHolder.vue?vue&type=script&setup=true&lang=ts"

import "./ContentHolder.vue?vue&type=style&index=0&id=64a422a3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a422a3"]])

export default __exports__